import { Directive, InjectionToken } from '@angular/core';

export const AD_SUFFIX: any = new InjectionToken<AtSuffix>('AtSuffix');

@Directive({
  selector: '[atSuffix]',
  providers: [{provide: AD_SUFFIX, useExisting: AtSuffix}]
})
export class AtSuffix {}
